// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyACgX7H232dMFke1savEwOdQq9cgXx54mk",
    authDomain: "sad-codes.firebaseapp.com",
    projectId: "sad-codes",
    storageBucket: "sad-codes.appspot.com",
    messagingSenderId: "137705240237",
    appId: "1:137705240237:web:f2a85bd99e87649884f824",
    measurementId: "G-QBHZGTGVV4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);